





















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { EmailSignupActions } from '@/actions/email-signup-actions';

@Component({})
export default class Signup extends Vue {
  email: string = '';

  async submitEmail() {
		if (this.email) {
			await EmailSignupActions.recordEmail(this.email);
			this.$router.push({ name: 'ThanksForEmail' });
		}
  }
}
